import Arrow from "./arrow.svg";

export default Arrow;
